<script setup lang="ts">
defineOptions({ name: 'ErrorFallback' })

defineProps<{ error: unknown }>()
const emit = defineEmits<{ (e: 'reset'): void }>()
</script>

<template>
  <div class="flex flex-col w-screen h-screen">
    <div class="flex flex-1 flex-col items-center justify-center px-6 text-center">
      <div class="text-body text-base mb-4">页面出错了</div>
      <button
        class="px-4 py-2 rounded-full bg-brand text-white text-sm"
        @click="emit('reset')"
      >
        重试
      </button>
    </div>
  </div>
</template>
